const docNumberLength = 10;

let fieldFormatter = {
  formatDocNumber(field) {
    if (field != null) {
      while (field.indexOf(" ") != -1) {
        field = field.replace(" ", "");
      }
      if (field.length > docNumberLength)
        return field.substr(0, docNumberLength);
    }
    return field;
  },
};

export default fieldFormatter;
